// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_3gc-1","btns":"_34veM","pageSize":"_2nFZ-","allPage":"_2lI4U"};